import { crud } from "./crud";
import { httpPost } from "../services/http";

export const translate = (state = [], action) => crud('translate', state, action, () => state);

export const getTranslate = (code) => {
	return (dispatch, state) => {
		if (state().translate.length === 0) {
			httpPost('translate/getAll', { relative: code })
				.then(data => {
					dispatch(data)
				});
		}
	}
};
